import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledGeneralList,
  StyledWrapper,
  StyledItem,
  StyledSpan,
  StyledIconNav
} from './style';
import { Download } from '../../../../assets/images';

/** Utils */
import { navigateToFile } from '../../../utils/navigate';

const GeneralList = ({
  dataList = [],
  active,
  defaultTextForNow,
  apiGeneralList
}) => (
  <StyledGeneralList>
    {dataList.length > 0 ? (
      dataList.map(item => (
        <StyledItem key={item.id}>
          <StyledSpan>{item.title}</StyledSpan>{' '}
          <StyledWrapper active={active}>
            {active && (
              <StyledIconNav
                onClick={() =>
                  navigateToFile(`${apiGeneralList}${item.clientPath}`)
                }
                svg={Download}
                size="s"
                hover
                color="dark"
              />
            )}
          </StyledWrapper>
        </StyledItem>
      ))
    ) : (
      <StyledItem key="defaultTextForNow">
        <StyledSpan>{defaultTextForNow}</StyledSpan>
      </StyledItem>
    )}
  </StyledGeneralList>
);

GeneralList.propTypes = {
  dataList: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string
    })
  ),
  active: PropTypes.bool,
  defaultTextForNow: PropTypes.string
};

GeneralList.defaultProps = {
  active: true,
  dataList: undefined,
  defaultTextForNow: undefined
};

export default GeneralList;
